import { z } from 'zod';
import { TaskStatus, TaskPriority, TaskRecurrence } from '../enums.js';
const isoDate = z.string().datetime().or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
const isoDateTime = z.string().datetime({ offset: true });
// projectId e clientId sono opzionali: un task può essere personale o assegnato
// tra utenti senza progetto. remindAt è un istante preciso (ISO con offset o Z).
export const createTaskInput = z.object({
    projectId: z.string().optional().nullable(),
    clientId: z.string().optional().nullable(),
    title: z.string().min(1).max(200),
    description: z.string().max(5000).optional().nullable(),
    status: z.nativeEnum(TaskStatus).default(TaskStatus.TODO),
    priority: z.nativeEnum(TaskPriority).default(TaskPriority.MEDIA),
    assigneeId: z.string().optional().nullable(),
    startDate: isoDate.optional().nullable(),
    dueDate: isoDate.optional().nullable(),
    remindAt: isoDateTime.optional().nullable(),
    recurrence: z.nativeEnum(TaskRecurrence).default(TaskRecurrence.NONE),
    isPrivate: z.boolean().default(false),
    estimateHours: z.coerce.number().min(0).max(10000).optional().nullable(),
    tag: z.string().max(40).optional().nullable(),
    parentTaskId: z.string().optional().nullable(),
    blockedByIds: z.array(z.string()).default([]),
});
export const updateTaskInput = createTaskInput.partial().extend({
    blockedReason: z.string().max(500).optional().nullable(),
    spentHours: z.coerce.number().min(0).max(100000).optional(),
    order: z.coerce.number().optional(),
});
// Kanban: `position` = indice 0..N nella colonna di destinazione (escluso il
// task spostato), oppure `order` esplicito. Se manca entrambi va in fondo.
export const moveTaskInput = z.object({
    status: z.nativeEnum(TaskStatus),
    position: z.coerce.number().int().min(0).optional(),
    order: z.coerce.number().optional(),
});
export const TaskScope = { MINE: 'mine', ASSIGNED_BY_ME: 'assigned-by-me', ALL: 'all' };
export const TaskDueFilter = { TODAY: 'today', OVERDUE: 'overdue', WEEK: 'week', NONE: 'none' };
const boolFromQuery = z.preprocess((v) => (typeof v === 'string' ? v === 'true' || v === '1' : v), z.boolean());
export const tasksListQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().trim().optional(),
    scope: z.nativeEnum(TaskScope).default(TaskScope.MINE),
    status: z.nativeEnum(TaskStatus).optional(),
    assigneeId: z.string().optional(),
    clientId: z.string().optional(),
    projectId: z.string().optional(),
    due: z.nativeEnum(TaskDueFilter).optional(),
    includeDone: boolFromQuery.optional(),
});
export const tasksSummaryQuery = z.object({
    scope: z.nativeEnum(TaskScope).default(TaskScope.MINE),
});
// Menzioni nel body: @[Nome Cognome](userId). Il server estrae gli id validi.
export const taskCommentInput = z.object({
    body: z.string().trim().min(1).max(5000),
});
export const taskChecklistInput = z.object({
    title: z.string().trim().min(1).max(200),
});
export const updateTaskChecklistInput = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    done: z.boolean().optional(),
    order: z.coerce.number().optional(),
});
export const timeEntryInput = z.object({
    projectId: z.string(),
    taskId: z.string().optional().nullable(),
    date: isoDate,
    hours: z.coerce.number().min(0.01).max(24),
    note: z.string().max(500).optional().nullable(),
});
//# sourceMappingURL=task.js.map